import { captureException } from '@sentry/react'
import StackAPI from '../../../lib/StackAPI'

const ENDPOINT = '/api/shipping/addresses'

export type AddressData = {
  address_1: string
  address_2: string
  city: string
  country: string
  phone_number: string
  state: string
  zip: string
}

type AddressResponse = {
  attributes: {
    suggested_address: AddressData
    status: 'invalid' | 'suggested'
    errors: Array<{ field: string; message: string }>
  }
}

type result =
  | {
      kind: 'success'
      data: AddressResponse
    }
  | {
      kind: 'error'
      message: string
    }

export const getAddresses = async (data: AddressData): Promise<result> => {
  const { post } = StackAPI()

  const headers = {
    Accept: 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json'
  }

  const params = {
    data: {
      attributes: {
        address_1: data.address_1 || '',
        address_2: data.address_2 || '',
        city: data.city || '',
        country: data.country || '',
        phone_number: data.phone_number || '',
        state: data.state || '',
        zip: data.zip || ''
      }
    }
  }

  const request = {
    path: ENDPOINT,
    params,
    headers
  }

  try {
    const response = await post(request)
    return {
      kind: 'success',
      data: response.data.data
    }
  } catch (error) {
    captureException(error, { extra: { params } })
    return {
      kind: 'error',
      message:
        'There was an error saving your form. Please try again. For help contact supplychain@stackcommerce.com.'
    }
  }
}
